__webpack_require__.hmrF = () => ("configuration." + __webpack_require__.h() + ".hot-update.json");